// src/components/Navbar.jsx - RESPONSIVE
import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon, SearchIcon, HeartIcon, Music, UserIcon,
  SettingsIcon, LogOutIcon, ChevronLeft, ChevronRight, Menu, X
} from 'lucide-react';
import { SlUserFollowing } from 'react-icons/sl';

const NAV_ITEMS = [
  { to: '/',        icon: HomeIcon,   label: 'Home'     },
  { to: '/search',  icon: SearchIcon, label: 'Search'   },
  { to: '/likes',   icon: HeartIcon,  label: 'Likes'    },
  { to: '/playlist',icon: Music,      label: 'Playlist' },
];

const GENERAL_ITEMS = [
  { to: '/profile',  icon: UserIcon,     label: 'Profile'  },
  { to: '/settings', icon: SettingsIcon, label: 'Settings' },
  { to: '/logout',   icon: LogOutIcon,   label: 'Logout'   },
];

function Navbar() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setMobileOpen(false);
      if (window.innerWidth < 1024 && window.innerWidth >= 768) {
        setCollapsed(true);
      } else if (window.innerWidth >= 1024) {
        setCollapsed(false);
      }
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const sidebarClass = [
    'sidebar',
    collapsed && !isMobile ? 'sidebar--collapsed' : '',
    isMobile && mobileOpen ? 'sidebar--mobile-open' : '',
    isMobile ? 'sidebar--mobile' : '',
  ].filter(Boolean).join(' ');

  return (
    <>
      {/* Mobile hamburger - only shows when sidebar is closed */}
      {isMobile && !mobileOpen && (
        <button className="navbar-hamburger" onClick={() => setMobileOpen(true)}>
          <Menu size={22} />
        </button>
      )}

      {/* Mobile backdrop */}
      {isMobile && mobileOpen && (
        <div className="navbar-backdrop" onClick={() => setMobileOpen(false)} />
      )}

      <div className={sidebarClass}>
        {/* Logo + Close button in same row for mobile */}
        <div className="logo">
          <div className="icon">
            <img src="/logo.png" className="logo-image" alt="logo" />
          </div>
          {!collapsed && <h2 className="logo-title">Aura Stream</h2>}
          
          {/* ✅ Close button - only in mobile view, positioned right side of logo */}
          {isMobile && (
            <button className="mobile-close-btn" onClick={() => setMobileOpen(false)}>
              <X size={20} />
            </button>
          )}
        </div>

        {/* Collapse toggle — desktop only */}
        {!isMobile && (
          <button className="sidebar-collapse-btn" onClick={() => setCollapsed(v => !v)}>
            {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          </button>
        )}

        {/* Menu */}
        <div className="menu">
          <section className="menu-items">
            {!collapsed && <div className="menu-title">MENU</div>}
            {NAV_ITEMS.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                className="menu-item"
                title={collapsed ? label : ''}
                onClick={() => isMobile && setMobileOpen(false)}
              >
                <div className="icon"><Icon size={20} /></div>
                {!collapsed && <div className="link_text">{label}</div>}
              </NavLink>
            ))}
          </section>
        </div>

        {/* General */}
        <div className="general">
          <section className="menu-items">
            {!collapsed && <div className="general-title">GENERAL</div>}
            {GENERAL_ITEMS.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                className="menu-item"
                title={collapsed ? label : ''}
                onClick={() => isMobile && setMobileOpen(false)}
              >
                <div className="icon"><Icon size={20} /></div>
                {!collapsed && <div className="link_text">{label}</div>}
              </NavLink>
            ))}
          </section>
        </div>
      </div>
    </>
  );
}

export default Navbar;